import auth from "../services/auth";
import router from "../router";
import SecureLS from "secure-ls";
import analyticsModule from "../modules/analytics";
import _ from "lodash";

const ls = new SecureLS({
    encodingType: "rc4",
    isCompression: false,
    encryptionSecret: "Zs%Ma??5Qn,!ZB#_nhM"
});
const analyticsIdentify = (data) => {
    window.analytics.identify(data.user.uuid, {
        merchant_name: data.merchant,
        merchant_uuid: data.user.merchant_uuid,
        plan_id: data.user.plan_id,
        role: data.user.role,
        email: data.user.email,
        id_no: data.user.id_number,
        designation: data.user.designation,
        phone: data.user.mobile,
        billing_email: data.merchantDetails.billing_email,
        billing_address: data.merchantDetails.billing_address,
    });
}
const isSegmentAnalyticsReady = 
    analyticsModule.state.isSegmentAnalyticsReady;

export default {
    namespaced: true,

    state: {
        user: auth.getUser(),
        token: auth.getToken(),
        login: auth.isLogin(),
        moduleAccess: auth.getModuleAccess(),
        enabledTopUps: auth.getEnabledTopUps(),
        onlineStoreVisibility: auth.getOnlineStoreVisibility(),
        loading: false,
        errors: {},
        message: null,
        whitelistType: auth.getWhitelistType(),
        merchant: auth.getMerchantName(),
        currentStep: auth.getCurrentStep(),
        hasPasswordUpdated: auth.getHasPasswordUpdated(),
        planId: auth.getPlanId(),
        unavailableToPlan: "Not available for your plan",
        moduleAccessId: auth.getModuleAccessId(),
        merchantDetails: auth.getMerchantDetails(),
        rewardVersion: [],
        otpTokenId: auth.getOtpTokenId(),
        email: auth.getEmail(),
        channel: auth.getChannel(),
        resendOtpResponse: null,
        autoLogout: 0,
        refreshToken: auth.getRefreshToken(),
        isCartLinkingEnabled: auth.getIsCartLinkingEnabled(),
        hubspotToken: auth.getHubspotToken()
    },

    mutations: {
        reset(state) {
            state.errors = {};
            state.message = null;
            state.loading = false;
        },
        setUser(state, payload) {
          state.user = payload;
        },
        logout(state) {
            auth.logoutNoUser();

            state.user = null;
            state.token = null;
            state.login = false;
            state.loading = false;
            state.merchant = null;
            state.currentStep = null;
            state.hasPasswordUpdated = false;

            router.go("/login");
        },

        login(state) {
            state.user = auth.getUser();
            state.token = auth.getToken();
            state.login = auth.isLogin();
            state.merchant = auth.getMerchantName();
            state.currentStep = auth.getCurrentStep();
            state.hasPasswordUpdated = auth.getHasPasswordUpdated();
            state.planId = auth.getPlanId();
            state.moduleAccess = auth.getModuleAccess();
            state.moduleAccessId = auth.getModuleAccessId();
            state.refreshToken = auth.getRefreshToken();
            state.hubspotToken = auth.getHubspotToken();
        },

        verifyOtp(state) {
            state.otpTokenId = auth.getOtpTokenId();
            state.email = auth.getEmail();
            state.channel = auth.getChannel();
            state.verifyOtp = auth.isVerified();
            state.user = auth.getUser();
            state.token = auth.getToken()
            state.hasPasswordUpdated = auth.getHasPasswordUpdated();
            state.moduleAccess = auth.getModuleAccess();
            state.moduleAccessId = auth.getModuleAccessId();
            state.refreshToken = auth.getRefreshToken();
            state.hubspotToken = auth.getHubspotToken();
        },

        moduleAccess(state) {
            state.moduleAccess = auth.getModuleAccess();
        },

        moduleAccessId(state) {
            state.moduleAccessId = auth.getModuleAccessId();
        },

        enabledTopUps(state) {
            state.enabledTopUps = auth.getEnabledTopUps();
        },

        onlineStoreVisibility(state) {
            state.onlineStoreVisibility = auth.getOnlineStoreVisibility();
        },

        whitelistType(state) {
            state.whitelistType = auth.getWhitelistType();
        },

        setLoading(state, payload) {
          state.loading = payload;
        },

        errors(state, errors) {
          state.errors = errors;
        },

        resetPassword(state, message) {
            state.loading = false;
            state.message = message;
        },

        resetToken(state, message) {
            state.loading = false;
            state.message = message;
        },

        merchant(state) {
            state.merchant = auth.getMerchantName();
        },
        hasPasswordUpdated(state) {
            state.hasPasswordUpdated = auth.getHasPasswordUpdated();
        },
        currentStep(state) {
            state.currentStep = auth.getCurrentStep();
        },
        planId(state) {
            state.planId = auth.getPlanId();
        },
        merchantDetails(state) {
            state.merchantDetails = auth.getMerchantDetails();
        },
        setRewardVersion(state, version) {
            state.rewardVersion = version;
        },
        setResendOtpResponse(state, payload) {
            state.resendOtpResponse = payload
        },
        autoLogout(state, status) {
            state.autoLogout = status
        }
    },

    getters: {
        moduleAccessId(state) {
            return state.moduleAccessId;
        },
        merchantDetails(state) {
            return state.merchantDetails;
        },
        user: state => state.user,
        rewardVersion: state => state.rewardVersion,
        loading: state => state.loading,
        cmsPermissions: state => _.get(state, "user.cms_permissions", []),
        merchantUuid: state => _.get(state, "user.merchant_uuid", null),
        userMetas: state => _.get(state, "user.metas", []),
        autoLogout: state => state.autoLogout,
        isAdmin: state => _.get(state, "user.role") === "admin",
    },

    actions: {
        verifyOtp: async ({ commit, dispatch, state }, param) => {
            try {
                commit("setLoading", true);
                await auth.verifyOtp(param.otp, param.otpTokenId)
                    .then(async () => {
                        commit("verifyOtp");
                        await dispatch("getTopUps");
                        await dispatch("getOnlineStoreVisibility")
                        await dispatch("getMerchant");
                        await dispatch("reloadWindow");
                    })

                if (isSegmentAnalyticsReady)
                    analyticsIdentify(state);

                if (!auth.getHasPasswordUpdated()) {
                    router.push("/account/security");
                } else {
                    router.push("/account/profile");
                }
                auth.removeOtp();
            } catch (errors) {
                commit("errors", errors);
            } finally {
              commit("setLoading", false);
            }
        },
        resendOtp: async ({ commit, dispatch, state }, param) => {
            try {
                commit("setLoading", true)
                const response = await auth.resendOtp(param.otpTokenId)
                await dispatch("reloadWindow");
                commit("setResendOtpResponse", response.message);
            } catch (errors) {
                commit("errors", errors);
            } finally {
              commit("setLoading", false);
            }
        },
        login: async ({ commit, dispatch, state }, param) => {
            try {
                commit("setLoading", true);
                if (param.rememberMe == 1) {
                    ls.set("rememberMe", JSON.stringify(param.username));
                    ls.set("rememberMePass", JSON.stringify(param.password));
                } else {
                    ls.remove("rememberMe");
                    ls.remove("rememberMePass");
                }
                await auth
                    .login(param.username, param.password)
                    .then(async () => {
                        commit("login");
                    })
                if (auth.getUser()) {
                    await dispatch("getTopUps");
                    await dispatch("getOnlineStoreVisibility")
                    await dispatch("getMerchant");
                    await dispatch("reloadWindow");
                }
                if (auth.getOtpTokenId()) {
                    router.push("/otp")
                } else {
                    if (isSegmentAnalyticsReady)
                        analyticsIdentify(state);   

                    if (!auth.getHasPasswordUpdated()) {
                        router.push("/account/security");
                    } else {
                        router.push("/account/profile");
                    }
                }
            } catch (errors) {
                commit("errors", errors);
            } finally {
              commit("setLoading", false);
            }
        },

        resetPassword: async ({ commit }, email) => {
            commit("setLoading", true);
            try {
                let response = await auth.resetPassword(email);
                commit("resetPassword", response.message);
            } catch (errors) {
                commit("errors", errors);
            } finally {
              commit("setLoading", false);
            }
        },

        resetToken: async ({ commit }, token) => {
            commit("setLoading", true);
            try {
                let response = await auth.resetToken(token);
                commit("resetToken", response.message);
            } catch (errors) {
                commit("errors", errors);
            } finally {
              commit("setLoading", false);
            }
        },

        getTopUps: async ({ commit }) => {
            commit("setLoading", true);
            try {
                await auth.getTopUpsApi();
                commit("enabledTopUps");
            } catch (errors) {
                commit("errors", errors);
            } finally {
              commit("setLoading", false);
            }
        },

        getOnlineStoreVisibility: async ({ commit }) => {
            commit("setLoading", true);
            try {
                await auth.getOnlineStoreVisibilityStatus();
                commit("onlineStoreVisibility");
            } catch (errors) {
                commit("errors", errors);
            } finally {
              commit("setLoading", false);
            }
        },

        reloadWindow() {
            window.location.reload();
        },

        getMerchant: async ({ commit }) => {
            commit("setLoading", true);

            try {
                await auth.getMerchantDetail();
                commit("merchant");
                commit("currentStep");
                commit("planId");
                commit("merchantDetails");
            } catch (errors) {
                commit("errors", errors);
            } finally {
              commit("setLoading", false);
            }
        },
        resetModuleAccess: async ({ commit }, modules) => {
            await auth.resetModuleAccess(modules);
            commit("moduleAccess");
        },
        getAdminSettings: async ({ commit, state }) => {
            commit("setLoading", true);

            try {
                const rewards_version = await auth.getAdminSettings();
                commit("setRewardVersion", rewards_version);
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("setLoading", false);
            }
        },

        logout: async ({ commit, state }) => {
            try {
                if (state.login) {
                    await auth.logout();
                    ls.remove("hubspotToken");
                    ls.remove("isInitialized")

                    state.user = null;
                    state.token = null;
                    state.login = false;
                    state.loading = false;
                    state.merchant = null;
                    state.currentStep = null;
                    state.hasPasswordUpdated = false;

                    if (state.autoLogout) {
                        router.push("/login");
                    } else {
                        router.go("/login");
                    }
                }
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("setLoading", false);
            }
        },
        refreshToken: async ({ commit, state }) => {
            try {
                let response = await auth.refreshToken(state.refreshToken);
                state.token = response.token;
            } catch (errors) {
                console.log(errors);
                commit("errors", errors);
            } finally {
              commit("setLoading", false);
            }
        },
        getUserDetails: async ({ commit, state }) => {
          commit("setLoading", true);

          try {
            if (_.get(state, "user.uuid")) {
              const response = await auth.getUserDetails(state.user.uuid)
              commit("setUser", {...state.user, ...response});
            }
          } catch (errors) {
            commit("errors", errors);
          } finally {
            commit("setLoading", false);
          }
        },
    }
};
